export default {
  NOT_IN_NARRATIVE: "narrativeFilter_NOT_IN_NARRATIVE",
  IN_NARRATIVE: "narrativeFilter_IN_NARRATIVE"
};
